import React from 'react';
import { Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import About from './pages/About';
import Wedding from './pages/Wedding';
import Glam from './pages/Glam';
import Editorial from './pages/Editorial';
import Products from './pages/Products';
import BookingPage from './pages/BookingPage';
import Contact from './pages/Contact';
import FAQ from './pages/Faq';
import Admin from './pages/admin pages/Admin';
import WeddingGallery from './pages/WeddingGallery'
import SpecialGallery from './pages/SpecialGallery'
import PhotoGallery from './pages/PhotoGallery'
import Pricing from './pages/Pricing'



const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/about" element={<About />} />
      <Route path="/wedding" element={<Wedding />} />
      <Route path="/glam" element={<Glam />} />
      <Route path="/editorial" element={<Editorial />} />
      <Route path="/booking" element={<BookingPage />} />
      <Route path="/products" element={<Products />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/faq" element={<FAQ />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/wedding-gallery" element={<WeddingGallery />} />
      <Route path="/special-gallery" element={<SpecialGallery />} />
      <Route path="/photo-gallery" element={<PhotoGallery />} />
      <Route path="/pricing" element={<Pricing />} />
    </Routes>
  );
};

export default AppRoutes;